import React, {useState} from "react";
import {getApiErrorMessage} from "../../../../helpers/errorMessage";
import {HttpErrorModel} from "../../../models/httpError";
import i18n from "i18next";
import {AxiosResponse} from "axios";
import Notification from "../notification/notification";

interface HttpErrorProps {
    cause: string;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    translatedFields?: any;
    translatedFieldsForEmpty?: any;
    object?: string;
    onClose?: () => void;
}

export function HttpError(props: HttpErrorProps) {
    const [display, setDisplay] = useState(true);
    const errorMessages: string[] = [];
    const cause = props.cause;
    const object = props.object;
    const responseData = props.response?.data;

    if (!props.response || !display) {
        return null;
    } else if (!responseData?.map) {
        return renderDefaultErrorMessage();
    }

    responseData.map((httpError: HttpErrorModel) => {
        const path = httpError.path;
        const translatedProperty = props.translatedFields ? props.translatedFields[path] : undefined;
        const translatedPropertyForEmpty = props.translatedFieldsForEmpty ? props.translatedFieldsForEmpty[path] : undefined;
        const apiErrorMessage = getApiErrorMessage(httpError.code, translatedProperty, translatedPropertyForEmpty, httpError.values, object, path);

        if (apiErrorMessage) {
            errorMessages.push(apiErrorMessage);
        }
    });

    if (errorMessages.length) {
        return (
            <Notification
                message={
                    <>
                        <b>{i18n.t("mappedErrorMessage", {cause})}:</b><>{renderMessage()}</>
                    </>
                }
                type="error"
                onClose={() => {
                    hideNotification();
                }}
            />
        );
    } else {
        return renderDefaultErrorMessage();
    }

    function renderMessage() {
        if (errorMessages.length === 1) {
            return (<>{errorMessages}</>);
        } else {
            return (
                <ul>
                    {errorMessages.map((message, index: number) => {
                        return <li key={`error-item-${index}`}>{message}</li>;
                    })}
                </ul>
            );
        }
    }

    function renderDefaultErrorMessage() {
        return (
            <Notification
                message={<b>{i18n.t("defaultErrorMessage", {messageSuffix: cause})}</b>}
                type="error"
                onClose={() => {
                    hideNotification();
                }}
            />
        );
    }

    function hideNotification(){
        if (props.onClose) props.onClose();
        setDisplay(false);
    }
}

